import React from "react";
import { connect } from "react-redux";
import HamburgerMenuButton from "./HamburgerMenuButton";
import { updateNavigationMenu } from "./../actions/navigationMenuActions";
import NavbarItems from "./NavbarItems";
import styles from "../../../assets/css/modules/navigation/havbar-items.css";
import Logout from "../../logout/Logout";

export const HamburgerMenu = ({ isHamburgerMenuOpen }) => {
  return (
    <div className="axa-hamburger-menu float-right">
      <HamburgerMenuButton />
      {isHamburgerMenuOpen ? (
        <div
          className="collapse navbar-collapse hidden-lg-up show"
          id="navbarNavAltMarkup"
          role="navigation"
          aria-label="Main"
        >
          <ul className={"navbar-nav " + styles.navbarItems}>
            <NavbarItems />
            <li className="nav-item">
              <Logout />
            </li>
          </ul>
          <div className="axa-hamburger-menu-mask" />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export const mapStateToHamburgerMenu = ({ navigationMenuReducer }) => {
  return {
    isHamburgerMenuOpen: navigationMenuReducer.isHamburgerMenuOpen
  };
};

export default connect(mapStateToHamburgerMenu, { updateNavigationMenu })(
  HamburgerMenu
);
